import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';

const {FiPhone,FiMail,FiMapPin,FiFacebook,FiInstagram}=FiIcons;

const Footer=()=> {
  const openingHours=[
    {day: 'Montag',hours: 'Geschlossen'},
    {day: 'Dienstag',hours: '10:00-12:00 & 12:30-17:30'},
    {day: 'Mittwoch',hours: '10:00-12:00 & 12:30-17:30'},
    {day: 'Donnerstag',hours: '10:00-12:00 & 12:30-17:30'},
    {day: 'Freitag',hours: '10:00-12:00 & 12:30-17:30'},
    {day: 'Samstag',hours: '10:00-15:00'},
    {day: 'Sonntag',hours: 'Geschlossen'}
  ];

  return (
    <footer className="bg-gray-900 text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <motion.div
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            className="space-y-6"
          >
            <Link to="/" className="block">
              <Logo className="h-12" showText={true} />
            </Link>
            <p
              style={{color: 'rgb(156,163,175)'}}
              className="text-gray-400 leading-relaxed"
            >
              Ihre Experten für Motorrad-Umbauten,Reparaturen und den Verkauf
              hochwertiger Bikes in Tapfheim. Qualität und Leidenschaft seit 2017.
            </p>
            <div className="flex space-x-4">
              <motion.a
                href="https://www.facebook.com/BavariaCustomBikes/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:bg-orange-500 hover:text-white transition-all duration-300"
                whileHover={{scale: 1.2,rotate: 15}}
                whileTap={{scale: 0.9}}
              >
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </motion.a>
              <motion.a
                href="https://www.instagram.com/bavaria.custom.bikes/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:bg-orange-500 hover:text-white transition-all duration-300"
                whileHover={{scale: 1.2,rotate: -15}}
                whileTap={{scale: 0.9}}
              >
                <SafeIcon icon={FiInstagram} className="w-5 h-5" />
              </motion.a>
            </div>
          </motion.div>

          <motion.div
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{delay: 0.1}}
            className="space-y-4"
          >
            <h3 className="text-lg font-bold text-white border-l-4 border-orange-500 pl-3">
              Kontakt
            </h3>
            <div className="space-y-4 pt-2">
              <motion.div className="flex items-start space-x-3 group" whileHover={{x: 5}}>
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-orange-500 mt-1 group-hover:text-white transition-colors" />
                <div className="text-gray-400 group-hover:text-gray-300 transition-colors">
                  <p>Ulmer Straße 56</p>
                  <p>86660 Tapfheim</p>
                </div>
              </motion.div>
              <motion.div className="flex items-center space-x-3 group" whileHover={{x: 5}}>
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-orange-500 group-hover:text-white transition-colors" />
                <div className="text-gray-400 group-hover:text-gray-300 transition-colors">
                  <p>0176/32543593</p>
                </div>
              </motion.div>
              <motion.div className="flex items-center space-x-3 group" whileHover={{x: 5}}>
                <SafeIcon icon={FiMail} className="w-5 h-5 text-orange-500 group-hover:text-white transition-colors" />
                <p className="text-gray-400 group-hover:text-gray-300 transition-colors">
                  info@bavaria-custom-bikes.com
                </p>
              </motion.div>
            </div>
          </motion.div>

          <motion.div
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{delay: 0.2}}
            className="space-y-4"
          >
            <h3 className="text-lg font-bold text-white border-l-4 border-orange-500 pl-3">
              Öffnungszeiten
            </h3>
            <div className="space-y-2 text-sm pt-2">
              {openingHours.map((item,index)=> (
                <div
                  key={index}
                  className="flex justify-between border-b border-gray-800 pb-1 last:border-0"
                >
                  <span className="text-gray-400">{item.day}:</span>
                  <span className={item.hours==='Geschlossen' ? 'text-gray-600' : 'text-orange-100'}>
                    {item.hours}
                  </span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{delay: 0.3}}
            className="space-y-4"
          >
            <h3 className="text-lg font-bold text-white border-l-4 border-orange-500 pl-3">
              Quick Links
            </h3>
            <div className="space-y-2 pt-2">
              <motion.div whileHover={{x: 5}}>
                <Link to="/leistungen" className="block text-gray-400 hover:text-orange-500 transition-all duration-200">
                  Unsere Leistungen
                </Link>
              </motion.div>
              <motion.div whileHover={{x: 5}}>
                <Link to="/zu-verkaufen" className="block text-gray-400 hover:text-orange-500 transition-all duration-200">
                  Motorräder zu verkaufen
                </Link>
              </motion.div>
              <motion.div whileHover={{x: 5}}>
                <Link to="/kontakt" className="block text-gray-400 hover:text-orange-500 transition-all duration-200">
                  Kontakt & Anfahrt
                </Link>
              </motion.div>
              <motion.div whileHover={{x: 5}}>
                <Link to="/impressum" className="block text-gray-400 hover:text-orange-500 transition-all duration-200">
                  Impressum
                </Link>
              </motion.div>
              <motion.div whileHover={{x: 5}}>
                <Link to="/datenschutz" className="block text-gray-400 hover:text-orange-500 transition-all duration-200">
                  Datenschutz
                </Link>
              </motion.div>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{opacity: 0}}
          whileInView={{opacity: 1}}
          viewport={{once: true}}
          transition={{delay: 0.4}}
          className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm"
        >
          <p>&copy;2026 Bavaria Custom Bikes. Alle Rechte vorbehalten.</p>
          <p className="mt-2 md:mt-0">
            Design by{' '}
            <a
              href="https://lima-service.de"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-orange-500 transition-colors"
            >
              LIMA-Service
            </a>
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;